export default class SfpBaseService {
	static returnResponse(response) {
		if (!response.ok)
			return response.json().then(error => {throw error});
		
		switch (response.status) {
			case 204: return true;
			default : return response.json();
		}
	};
}


// WEBPACK FOOTER //
// ./src/service/sfp/sfp-base-service.js